import {
  CONVERSATION_PERMISSIONS,
  ROLES,
} from 'dashboard/constants/permissions';
import { frontendURL } from 'dashboard/helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/after-sales'),
    name: 'after_sale_cases_index',
    component: () => import('./Index.vue'),
    meta: { permissions: [...ROLES, ...CONVERSATION_PERMISSIONS] },
  },
];
